/* eslint-disable @next/next/no-img-element */

import React, { useRef, useState } from 'react';

import styles from './styles.module.scss'
import BlueArrow from '../../public/assets/icons/blue-arrow.svg';
import eventGTM from '../../lib/gtag';

interface ITextAccordion {
  header: string;
  text: string | JSX.Element;
  className?: string;
}

export default function TextAccordion({ header, text, className }: ITextAccordion) {
  const [open, setOpen] = useState(false);

  const textRef = useRef<HTMLParagraphElement>(null);

  const onClick = () => {
    eventGTM('clickedOnExtendBio')

    if (!open) {
      textRef?.current?.classList.add(styles.openningText);

      setTimeout(() => {
        textRef?.current?.classList.remove(styles.openningText);
        textRef?.current?.classList.add(styles.opennedText);
      }, 290)
    }
    else {
      textRef?.current?.classList.remove(styles.opennedText);
      textRef?.current?.classList.add(styles.openningText);
      
      setTimeout(() => {
        textRef?.current?.classList.remove(styles.openningText);
      }, 10)
    }

    setOpen(!open);
  }

  return (
    <div className={`${styles.accordion} ${className}`}>
      <div className={styles.openner} onClick={onClick}>
        <h1 className={`${styles.header} perfect-subtext`}>{header}</h1>
        <img className={`${styles.arrow} ${open && styles.open}`} src={BlueArrow.src} alt="arrow" />
      </div>

      <p className={`${styles.text} perfect-bio`} ref={textRef}>{text}</p>
    </div>
  )
};
